module.exports = __webpack_public_path__ + "b208be8d33233aa14791ec2a8061478b.svg";